"use client";
import React from "react";
import { motion } from "motion/react";
import { Sparkles } from "lucide-react";

const getInitials = (name) => {
    if (!name) return "";
    const parts = name.split(" ");
    if (parts.length >= 2) {
        return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    return parts[0][0].toUpperCase();
};

export const TestimonialsColumn = ({ className, testimonials, duration = 15 }) => {
    return (
        <div className={className}>
            <motion.div
                animate={{
                    translateY: "-50%",
                }}
                transition={{
                    duration: duration,
                    repeat: Infinity,
                    ease: "linear",
                    repeatType: "loop",
                }}
                className="flex flex-col gap-6 pb-6"
            >
                {[...new Array(2)].map((_, index) => (
                    <React.Fragment key={index}>
                        {testimonials.map((t, i) => (
                            <div
                                className="p-8 rounded-[32px] border border-gray-100 bg-white shadow-2xl shadow-gray-200/50 max-w-sm w-full transition-all duration-300 hover:scale-[1.02]"
                                key={`${index}-${i}`}
                            >
                                {/* Star Rating */}
                                <div className="flex gap-1 mb-4">
                                    {[...Array(5)].map((_, starIdx) => (
                                        <Sparkles key={starIdx} className="w-4 h-4 text-black opacity-80" />
                                    ))}
                                </div>

                                <div className="text-gray-600 text-lg leading-relaxed mb-6 italic">
                                    "{t.comment}"
                                </div>

                                <div className="flex items-center gap-4 mt-5 pt-6 border-t border-gray-100">
                                    <div className="h-12 w-12 rounded-2xl bg-black flex items-center justify-center text-white font-bold text-lg shadow-lg">
                                        {getInitials(t.name)}
                                    </div>
                                    <div className="flex flex-col">
                                        <div className="font-bold tracking-tight text-black text-base">{t.name}</div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </React.Fragment>
                ))}
            </motion.div>
        </div>
    );
};
